import React, { useEffect, useState } from "react";
import style from './HealthStatus.module.scss';
import StatusItem from './StatusItem'
import ProgressItem from './Item'
import HealthStatusTextField from './HealthStatusTextField'
import { REPORT_LAYOUTS } from '../../../helpers/textFit'
import { filterHealthStatus } from '../../../store/actions/projects.actions'
import $ from "jquery";
import { useDispatch } from "react-redux";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { getEditPermission, resetUtcDate } from "../../../helpers/utils";
import { LockSvg, ArrowLeft, ArrowRight, CalendarIcon } from "../../../modules/default-svg";
import moment from "moment/moment";
dayjs.extend(utc);

const HealthStatus = (props) => {
    const {
        projectID,
        metrixList,
        updateStatusKPI,
        getMetrics,
        handleUpdateGLobalStatus,
        handleUpdatePeriod,
        loading,
    } = props;
    const [progressTracker, setProgressTracker] = useState({});
    const [progressTrackerPeriod, setProgressTrackerPeriod] = useState('');
    const settings = JSON.parse(localStorage.getItem("settings"));
    const [setting] = useState(settings);
    const [global, setGLobal] = useState([]);
    const [scope, setScope] = useState([]);
    const [time, setTime] = useState([]);
    const [cost, setCost] = useState([]);
    const [quality, setQuality] = useState([]);
    const [issues, setIssues] = useState([]);
    const [risks, setRisks] = useState([]);
    const [resources, setResources] = useState([]);
    const [currentPeriodProgress, setCurrentPeriodProgress] = useState({});
    const [nextPeriodProgressForecast, setNextPeriodProgressForecast] = useState({});
    const [majorRisksIssues, setMajorRisksIssues] = useState({});
    const [specialConcerns, setSpecialConcerns] = useState("");
    const [readOnly, setReadOnly] = useState(false);
    const dispatch = useDispatch();

    const handleUpdateStatus = (payload) => {
        updateStatusKPI({ id: projectID, payload })
        if (payload.kpi === "ProjectHealth")
            handleUpdateGLobalStatus({ isForecast: payload.isForecast, status: payload.status });
    }

    const addDays = (date, days) => moment(date, "YYYY-MM-DD").add(days, "days").format("YYYY-MM-DD");
    const subtractDays = (date, days) => addDays(date, -days);

    const handleCurrent = () => {
        const data = { date: subtractDays(metrixList?.period?.startCurrent, 7) };
        projectID && dispatch(filterHealthStatus({ id: projectID, data }));
    };

    const handleTrending = () => {
        const data = { date: addDays(metrixList?.period?.endCurrent, 7) };
        projectID && dispatch(filterHealthStatus({ id: projectID, data }));
    };

    useEffect(() => {
        getMetrics(projectID);
    }, []);

    useEffect(() => {
        if (metrixList.hasOwnProperty('period') || metrixList.hasOwnProperty('healthStatus')) {
            setGLobal(metrixList.healthStatus && metrixList.healthStatus.global);
            setScope(metrixList.healthStatus && metrixList.healthStatus.scope);
            setTime(metrixList.healthStatus && metrixList.healthStatus.time);
            setCost(metrixList.healthStatus && metrixList.healthStatus.cost);
            setQuality(metrixList.healthStatus && metrixList.healthStatus.quality);
            setIssues(metrixList.healthStatus && metrixList.healthStatus.issues_Concerns);
            setRisks(metrixList.healthStatus && metrixList.healthStatus.risks);
            setResources(metrixList.healthStatus && metrixList.healthStatus.resources_Team);
            setProgressTracker(metrixList.progressTracker);
            setProgressTrackerPeriod(metrixList.progressTracker && metrixList.progressTracker.period);
            const data = {
                startCurrent: metrixList?.period ? moment(metrixList?.period?.startCurrent).toDate() : '',
                endCurrent: metrixList?.period ? moment(metrixList?.period?.endCurrent).toDate() : '',
            };

            if (metrixList?.period?.startCurrent && metrixList?.period?.endCurrent) {
                $("input[name='datetimes']").daterangepicker({
                    startDate: data.startCurrent,
                    endDate: data.endCurrent,
                    locale: {
                        format: setting.regionalSettings.dateFormat.toUpperCase()
                    }
                });
                handleUpdatePeriod(moment(metrixList?.period?.endCurrent).format('YYYY-MM-DD'));
            }

            $("input[name='datetimes']").on('apply.daterangepicker', (e, picker) => {
                const newStartDate = picker.startDate.format('YYYY-MM-DD');
                dispatch(filterHealthStatus({ id: projectID, data: { date: newStartDate } }));
            });

            setReadOnly(!getEditPermission("Project") || metrixList?.isLocked);
            if (metrixList?.healthStatus?.global) {
                metrixList?.healthStatus?.global?.map(kpi => handleUpdateGLobalStatus(kpi))
            }
            return () => {
                $("input[name='datetimes']").daterangepicker('destroy');  // Clean up the daterangepicker instance on unmount or update
            };
        }
    }, [metrixList])


    useEffect(() => {
        if (Object.keys(progressTracker).length > 0) {
            setCurrentPeriodProgress(progressTracker.currentPeriodProgress);
            setNextPeriodProgressForecast(progressTracker.nextPeriodProgressForecast);
            setMajorRisksIssues(progressTracker.majorRisksIssues || {});
            setSpecialConcerns(progressTracker.specialConcerns || "");
        }
    }, [progressTracker]);

    if (loading) {
        return (
            <div className={style.mainScroller}>
                <div className={style.sectionCard}>
                    {Array.from({ length: 8 }).map((_, i) => (
                        <div key={i} className={style.skeletonKpiRow}>
                            <div className={`${style.skeletonShimmer} ${style.skeletonPill}`} />
                            <div className={`${style.skeletonShimmer} ${style.skeletonBar}`} />
                        </div>
                    ))}
                </div>
                <div className={`${style.sectionCard} mt-3`}>
                    <div className="row gx-3 mt-2">
                        <div className="col-6">
                            <div className={`${style.skeletonShimmer} ${style.skeletonTextArea}`} />
                        </div>
                        <div className="col-6">
                            <div className={`${style.skeletonShimmer} ${style.skeletonTextArea}`} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className={style.mainScroller}>
                <div className={style.sectionCard}>
                    <div className={style.kpiRow}>
                        <span className={`${style.kpiLabelPill} ${style.kpiHeaderPill}`}>KPI</span>
                        <div className={style.kpiRowBody}>
                            {/* Mirrors StatusItem's col-12 > rowsFlex > "flex col-2" (two w-50 halves) structure
                                below, so the Current/Trending header pills land on the exact same pixel
                                boundaries as the status pills in every KPI row underneath. */}
                            <div className="row gx-3 w-100">
                                <div className="col-12">
                                    <div className={`${style.rowsFlex} ${style.isGlobal}`}>
                                        <div className="flex col-2">
                                            <div className="w-50 d-flex align-items-center justify-content-center">
                                                <span className={`${style.periodLabelPill} ${style.kpiHeaderPill}`}>Current</span>
                                            </div>
                                            <div className="w-50 d-flex align-items-center justify-content-center">
                                                <span className={`${style.periodLabelPill} ${style.kpiHeaderPill}`}>Trending</span>
                                            </div>
                                        </div>
                                        <div className={`col-10 ${style.kpiGlobalRowBody}`}>
                                            <div className={style.leftBarContent}>
                                                <button
                                                    type="button"
                                                    className={`${style.hsHeaderArrow}`}
                                                    onClick={handleCurrent}
                                                >
                                                    <ArrowLeft />
                                                </button>
                                                <div className={style.rangeDateWrapper}>
                                                    <input
                                                        type="text"
                                                        className={style.rangeDateInput}
                                                        name="datetimes"
                                                    />
                                                    <CalendarIcon />
                                                </div>
                                                <button
                                                    type="button"
                                                    className={`${style.hsHeaderArrow}`}
                                                    onClick={handleTrending}
                                                >
                                                    <ArrowRight />
                                                </button>
                                            </div>
                                            <StatusItem item={global} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} isLocked={!!metrixList?.isLocked} isGlobal />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={style.kpiRow}>
                        <span className={style.kpiLabelPill}>Scope</span>
                        <div className={style.kpiRowBody}>
                            <div className="row gx-3 w-100">
                                <StatusItem item={scope} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                            </div>
                        </div>
                    </div>
                    <div className={style.kpiRow}>
                        <span className={style.kpiLabelPill}>Time</span>
                        <div className={style.kpiRowBody}>
                            <div className="row gx-3 w-100">
                                <StatusItem item={time} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                            </div>
                        </div>
                    </div>
                    <div className={style.kpiRow}>
                        <span className={style.kpiLabelPill}>Qual.</span>
                        <div className={style.kpiRowBody}>
                            <div className="row gx-3 w-100">
                                <StatusItem item={quality} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                            </div>
                        </div>
                    </div>
                    <div className={style.kpiRow}>
                        <span className={style.kpiLabelPill}>Issues/Concerns</span>
                        <div className={style.kpiRowBody}>
                            <div className="row gx-3 w-100">
                                <StatusItem item={issues} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                            </div>
                        </div>
                    </div>
                    <div className={style.kpiRow}>
                        <span className={style.kpiLabelPill}>Risks</span>
                        <div className={style.kpiRowBody}>
                            <div className="row gx-3 w-100">
                                <StatusItem item={risks} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                            </div>
                        </div>
                    </div>
                    <div className={style.kpiRow}>
                        <span className={style.kpiLabelPill}>Res./Team</span>
                        <div className={style.kpiRowBody}>
                            <div className="row gx-3 w-100">
                                <StatusItem item={resources} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                            </div>
                        </div>
                    </div>
                    <div className={style.kpiRow}>
                        <span className={style.kpiLabelPill}>Cost</span>
                        <div className={style.kpiRowBody}>
                            <div className="row gx-3 w-100">
                                <StatusItem item={cost} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${style.sectionCard} mt-3`}>
                    <div className="row gx-3 mt-2">
                        <div className="col-6">
                            <div className="d-flex justify-content-center mb-3">
                                <span className={`${style.periodLabelPill} ${style.kpiSectionPill}`}>Current Period Progress</span>
                            </div>
                            <ProgressItem title="Accomplishment's Highlights" placeholder="Accomplished highlights is empty" kpi="CP_Accomplished" period={progressTrackerPeriod} item={currentPeriodProgress && currentPeriodProgress.accomplished} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} maxItems={12}/>
                            <ProgressItem title="Planned but not accomplished" placeholder="Planned but not accomplished empty" kpi="CP_Planned" period={progressTrackerPeriod} item={currentPeriodProgress && currentPeriodProgress.planned} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                        </div>
                        <div className="col-6">
                            <div className="d-flex justify-content-center mb-3">
                                <span className={`${style.periodLabelPill} ${style.kpiSectionPill}`}>Next Period Progress</span>
                            </div>
                            <ProgressItem title="Planned’s Highlights/ Focus" placeholder="Planned’s Highlights/ Focus is empty" kpi="NP_Planned" period={progressTrackerPeriod} item={nextPeriodProgressForecast && nextPeriodProgressForecast.planned} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                            <ProgressItem title="Communication Highlights & Priorities" placeholder="Communication Highlights & Priorities is empty" kpi="NP_Communication" period={progressTrackerPeriod} item={nextPeriodProgressForecast && nextPeriodProgressForecast.communication} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                        </div>
                    </div>
                </div>
                <div className="row gx-3 mt-3">
                    <div className="col-6">
                        <HealthStatusTextField
                            title="Major Risks and Mitigation"
                            layout={REPORT_LAYOUTS.majorRisksBox}
                            placeholder="Major Risks and Mitigation is empty"
                            content={majorRisksIssues?.risksMitigation || ''}
                            disabled={readOnly}
                            onChange={(e) => handleUpdateStatus({ kpi: 'RisksMitigation', description: e, period: progressTrackerPeriod })}
                        />
                    </div>
                    <div className="col-6">
                        <HealthStatusTextField
                            title="Major Dependencies"
                            layout={REPORT_LAYOUTS.majorDependenciesBox}
                            placeholder="Major Dependencies is empty"
                            content={majorRisksIssues?.dependencies || ''}
                            disabled={readOnly}
                            onChange={(e) => handleUpdateStatus({ kpi: 'Dependencies', description: e, period: progressTrackerPeriod })}
                        />
                    </div>
                </div>
                <div className="row gx-3 mt-3">
                    <div className="col-12">
                        <HealthStatusTextField
                            title="Special Concerns"
                            layout={REPORT_LAYOUTS.specialConcernsBox}
                            placeholder="Special Concerns is empty"
                            content={specialConcerns || ''}
                            disabled={readOnly}
                            onChange={(e) => handleUpdateStatus({ kpi: 'SpecialConcerns', description: e, period: progressTrackerPeriod })}
                        />
                    </div>
                </div>
            </div >
        </>
    );
}

export default HealthStatus;